const DossierType = Object.freeze({
  CONTRAT: 'CON',
  DECES: 'DEC',
  EXHUMATION: 'EXH',
  DEMARCHE: 'DEM',
  RAPATRIEMENT: 'RAP',
  MARBRERIE: 'MAR'
})

export default DossierType
